<template>
  <div id="app">
    <SvgDefs/>
    <SiteNav v-if="siteNav" />
    <SiteNavHamburger v-if="!siteNav" :isHome="isHome" />
    <transition name="vPage" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import SvgDefs from '@/components/SvgDefs';
import SiteNav from '@/components/SiteNav';
import SiteNavHamburger from '@/components/SiteNavHamburger';
import { mapState } from 'vuex'

export default {
  data() {
    return {
      siteNav: true
    };
  },
  components: {
    SvgDefs,
    SiteNav,
    SiteNavHamburger
  },
  computed: {
    ...mapState({
      isHome: state => state.isHome
    })
  },
  mounted() {
  },
  methods: {}
};
</script>

<style lang="scss">

  html {
    -webkit-text-size-adjust: 100%;
    height: 100%;
  }
  svg path {
    fill: inherit;
  }
  body {
    height: 100%;
    padding: 0;
    margin: 0;
    color: $fontBodyColor;
    @include fontBody();
    @include fontBodyLight();
    line-height: 28px;
    line-height: 32px;
    font-size: 18px;
    background: #fff;
    background: $greyLight;
  }
  #app {
    height: 100%;
  }
  h1,
  h2,
  h3,
  h4,
  h5 {
    @include fontHead();
    color: $fontHeadColor;
    font-size: 48px;
    line-height: 60px;

    @media screen and (max-width: $breakSmall) {
      font-size: 36px;
      line-height: 48px;
    }
  }
  h2 {
    font-size: 34px;
    line-height: 54px;

    @media screen and (max-width: $breakSmall) {
      font-size: 26px;
      line-height: 40px;
    }
  }
  h3 {
    font-size: 26px;
    line-height: 38px;
  }
  h4 {
    font-size: 16px;
    line-height: 22px;
    margin: 10px 0 5px 0;
  }
  h5 {
    font-size: 14px;
    line-height: 20px;
    margin: 10px 0 5px 0;
  }
  p {
    margin: 0 0 15px 0;

    &:last-child {
      margin: 0 !important;
    }
  }
  * {
    box-sizing: border-box;
  }
  input,
  select,
  textarea {
    -webkit-appearance: none;
    -moz-appearance: none;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    appearance: none;
    border-radius: 0;

    &::-webkit-input-placeholder {
      color: #aaa;
    }
    &::-moz-placeholder {
      color: #aaa;
    }
    &:-ms-input-placeholder {
      color: #aaa;
    }
    &:-moz-placeholder {
      color: #aaa;
    }
    &:focus {
      -webkit-appearance: none;
      -moz-appearance: none;
      -webkit-border-radius: 0;
      -moz-border-radius: 0;
      appearance: none;
      border-radius: 0;
      outline: none;
    }
  }
  a, .link {
    color: #000;
    cursor: pointer;
    text-decoration: underline;
    transition: all 300ms;

    &:focus {
      outline: none;
    }
  }
  a:hover, .link:hover {
    color: $linkColorActive;
    text-decoration: none;
  }
  strong {
    @include fontBodyBold;
    color: #000;
  }

  // override vue-swiper styles
  .swiper-container {
    display: none;

    @media screen and (max-width: $breakSmall) {
      display: block;
    }
  }
  .swiper-pagination-bullet-active {
    background: #000 !important;
  }

  // Vue Transitions

  .vPage-enter {
    opacity: 0;
  }
  .vPage-enter-active {
    transition: opacity 700ms ease;
  }
  .vPage-leave {}
  .vPage-leave-active {
    transition: opacity 700ms ease;
    opacity: 0;
  }

  .vFade-enter-active {
    transition: all 400ms ease;
  }
  .vFade-leave-active {
    transition: all 400ms ease;
  }
  .vFade-enter,
  .vFade-leave-to {
    opacity: 0;
  }


  .vFadeMobile-enter-active {
    transition: all 400ms ease;
  }
  .vFadeMobile-leave-active {
    transition: all 400ms ease;
  }
  .vFadeMobile-enter,
  .vFadeMobile-leave-to {
    opacity: 0;

    @media screen and (max-width: $breakSmall) {
      transform: translateY(100%);
      opacity: 1;
    }
  }
</style>
